import { Menu } from '@mantine/core';

const MantineMenu = ({ children, trigger, className, transitionProps, withArrow, position, withinPortal, disabled }: any) => {
    return <Menu
        classNames={className}
        transitionProps={transitionProps}
        withArrow={withArrow || false}
        position={position}
        disabled={disabled}
        withinPortal={withinPortal || false}
        trigger={trigger}
    >
        {children}
    </Menu>;
};

const MantineMenuTarget = ({ children }: any) => {
    return <Menu.Target>{children}</Menu.Target>;
};

const MantineMenuDropdown = ({ children, className }: any) => {
    return <Menu.Dropdown className={className}>{children}</Menu.Dropdown>;
};
const MantineMenuLabel = ({ children, className, onClick }: any) => {
    return <Menu.Label className={`${className}`} onClick={onClick}>{children}</Menu.Label>;
};

const MantineMenuItem = ({ leftSection, color, children, className, onClick }: any) => {
    return (
        <Menu.Item leftSection={leftSection} color={color} className={` ${className}`} onClick={onClick}>
            {children}
        </Menu.Item>
    );
};

export { MantineMenu, MantineMenuTarget, MantineMenuDropdown, MantineMenuItem, MantineMenuLabel };
